// import { useEffect, useState } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import firebase from 'firebase/app';

import useAuthentication from 'components/private/Login/authentication/useAuthentication';
import { Summary } from 'services/hitchit/types/admin/Summary';
import { getUserSummary } from 'services/fetcher/hikeCalls';

export default function useAdmin({
  enableUserSummaryQuery,
}: { enableUserSummaryQuery?: boolean; adminUser?: firebase.User } = {}): {
  userSummaryQuery?: UseQueryResult<Summary | undefined>;
} {
  const { user } = useAuthentication();

  return {
    userSummaryQuery: useQuery<Summary | undefined, any>(['adminUserSummary', user], () =>
      enableUserSummaryQuery && user ? getUserSummary(user) : undefined
    ),
  };
}
